class KinrossCartPairing extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-pairing-add]')?.addEventListener('click', () => this.add());
  }

  async add() {
    const button = this.querySelector('[data-pairing-add]');
    if (button.disabled) return;
    const error = this.querySelector('[data-pairing-error]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    const cartPage = document.querySelector('cart-items');
    const drawer = document.querySelector('cart-drawer');
    const sections = cartPage ? cartPage.getSectionsToRender() : drawer?.getSectionsToRender() || [];
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items:[{id:Number(this.dataset.variantId),quantity:Number(this.dataset.quantity),
            properties:{_kinross_pairing:'cart_scarf',_kinross_source_product:this.dataset.sourceProduct,_kinross_source_color:this.dataset.sourceColor}}],
          sections:sections.map(section => section.section || section.id), sections_url:window.location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Unable to add item');
      if (cartPage) {
        for (const section of sections) {
          const host = document.getElementById(section.id);
          const target = host?.querySelector(section.selector) || host;
          const html = data.sections?.[section.section || section.id];
          if (target && html) target.innerHTML = cartPage.getSectionInnerHTML(html, section.selector);
        }
      } else if (drawer) {
        drawer.setActiveElement(button);
        drawer.renderContents(data);
      } else {
        window.location.assign(window.routes.cart_url);
        return;
      }
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'cart-pairing', cartData:data});
      (document.getElementById(cartPage ? 'checkout' : 'CartDrawer-Checkout'))?.focus();
    } catch (failure) {
      error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('kinross-cart-pairing')) customElements.define('kinross-cart-pairing', KinrossCartPairing);
